import { render, staticRenderFns } from "./reset_pwd.vue?vue&type=template&id=354645ac&scoped=true"
import script from "./reset_pwd.vue?vue&type=script&lang=js"
export * from "./reset_pwd.vue?vue&type=script&lang=js"
import style0 from "./reset_pwd.vue?vue&type=style&index=0&id=354645ac&prod&scoped=true&lang=css"
import style1 from "./reset_pwd.vue?vue&type=style&index=1&id=354645ac&prod&lang=css"
import style2 from "./reset_pwd.vue?vue&type=style&index=2&id=354645ac&prod&scoped=true&lang=css"
import style3 from "./reset_pwd.vue?vue&type=style&index=3&id=354645ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354645ac",
  null
  
)

export default component.exports